<template>
  <div>
    <a-card :bordered="false" class="card-product header-solid mb-24">
      <template #title>
        <h6>跟单设置: <span style="color: #EC575BFF;">{{ name }}</span></h6>
      </template>
      <div>
        <a-form
            :form="form"
            :hideRequiredMark="true"
            style="width: 70%"
        >
          <a-row :gutter="[24]" type="flex" justify="start">
            <a-alert
                type="info"
                style="margin: 20px 0; width: 80%;"
                show-icon
                v-if="trader_platform === '8'"
            >
              <p slot="message">
                <span style="font-weight: 600">欧意OKX交易所延迟提示：</span>
                <br>
                <span class="text-gray-7" style="font-size: 12px">此延迟为交易所官方设置，非跟单工具所导致！</span>
              </p>
              <p slot="description"><span style="font-weight: 600">跟单隐藏带单：</span>开仓5分钟延迟，加仓、减仓、平仓无延迟</p>
            </a-alert>

            <a-col :span="14" v-if="trader_platform === '7'">
              <a-form-item class="mb-10" label="交易员平台ID" :colon="false">
                <a-input placeholder="eg. 3887627985594221568"
                         v-decorator="['unique_name',{ rules: [{ required: true, message: '请输入你要跟随的交易员平台ID' }] },]"/>
              </a-form-item>
              <span class="text-gray-6" style="font-weight: 400; font-size: 12px">
                    PC访问交易员主页，在域名末尾，查看交易员ID
                </span>
              <br/>
              <span class="text-gray-6" style="font-weight: 400; font-size: 12px;width: 100%">
                    eg. https://www.binance.com/zh-CN/copy-trading/lead-details/3887627985594221568?timeRange=7D
              </span>
            </a-col>
            <a-col :span="14" v-else-if="trader_platform === '8'">
              <a-form-item class="mb-10" label="交易员平台ID" :colon="false">
                <a-input placeholder="eg. EEA569A04A98D4E9"
                         v-decorator="['unique_name',{ rules: [{ required: true, message: '请输入你要跟随的交易员平台ID' }] },]"/>
              </a-form-item>
              <span class="text-gray-6" style="font-weight: 400; font-size: 12px">
                    PC访问交易员主页，在域名末尾，查看交易员ID
                </span>
              <br/>
              <span class="text-gray-6" style="font-weight: 400; font-size: 12px;width: 100%">
                    eg. https://www.okx.com/cn/copy-trading/account/EEA569A04A98D4E9?tab=swap
              </span>
            </a-col>

            <a-col :span="14" v-if="trader_platform === '7'">
              <a-form-item class="mb-10" label="交易员实盘类型" :colon="false">
                <a-radio-group v-model:value="role_type" button-style="solid">
                  <a-radio-button value="1">合约带单</a-radio-button>
                  <a-radio-button value="3">合约排行榜</a-radio-button>
                </a-radio-group>
              </a-form-item>
              <span class="text-gray-6" style="font-weight: 400; font-size: 12px">
                    交易员实盘类型说明
              </span>
              <br/>
              <span class="text-gray-6" style="font-weight: 400; font-size: 12px">
                    合约带单：可以在平台合约跟单中找到的带单项目
              </span>
              <br/>
              <span class="text-gray-6" style="font-weight: 400; font-size: 12px">
                    合约排行榜：平台合约排行榜中的个人交易员
              </span>
              <br/>
              <span class="text-gray-6" style="font-weight: 400; font-size: 12px">
                <a-icon type="warning" theme="outlined"/>
                    请注意，选择错误项目类型将导致无法跟单！
              </span>
            </a-col>

            <a-col :span="14">
              <a-form-item class="mb-10" label="选择你的跟单API" :colon="false">
                <a-select v-decorator="[
                      'id',
                      {
                        rules: [{ required: true, message: '选择你的跟单API' }]
                      }
                    ]">
                  <a-select-option v-for="option in apiOptions" :key="option.id" :id="option.id">
                    {{ option.api_name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="14">
              <a-form-item class="mb-10" label="跟单模式" :colon="false">
                <a-radio-group button-style="solid" v-decorator="['follow_type', { initialValue: '2' }]">
<!--                  <a-radio-button value="1" v-if="trader_platform === '4'">固定金额</a-radio-button>-->
                  <a-radio-button value="2">智能跟单</a-radio-button>
                </a-radio-group>
              </a-form-item>
            </a-col>

            <a-col :span="14" style="margin-bottom:10px;margin-top:5px;background-color: #e9f7fe;padding: 10px;border-radius: 5px" v-if="form.getFieldValue('follow_type') === '2'">
              <a-row type="flex" align="middle">
                <a-col :span="24" :md="12" class="col-info">
                  <div class="avatar-info">
                    <p class="font-semibold m-0" style="font-size: 13px;font-weight: 600;color: #141414;">倍投模式 (可选)</p>
                  </div>
                </a-col>
                <a-col :span="24" :md="12" style="display: flex; align-items: center; justify-content: flex-end">
                  <small class="mr-5" v-if="multiple_visible === false">关闭</small>
                  <small class="mr-5" v-if="multiple_visible === true">开启</small>
                  <a-switch default-checked v-model="multiple_visible" @change="onChangeMode"/>
                </a-col>
              </a-row>
              <a-form-item class="mb-10" label="加倍倍数(默认为1)" :colon="false" v-if="multiple_visible">
                <a-input placeholder="eg. 2（在原有开单保证金的基础上 * 2，多承担一倍爆仓风险）"
                         v-decorator="['multiple',{ rules: [
                             { required: true, message: '请输入你要加倍投注的倍数！' },
                             { min: 1, message: '长度不能少于1位！' },
                             { validator: (rule, value, callback) => {
                                const numberValue = parseFloat(value);
                                if (isNaN(numberValue) || !isFinite(numberValue)) {
                                  callback('请输入有效的数字！');
                                } else if (numberValue < 1) {
                                  callback('输入数值必须大于等于1');
                                } else if (!/^\d+(\.\d+)?$/.test(value)) {
                                  callback('请输入标准的数字格式，不要包含非数字字符');
                                }else {
                                  callback();
                                }
                              },
                              // message: '输入数值必须大于5',
                              trigger: 'change'
                            },
                          ]
                         },]"/>
              </a-form-item>
              <div v-if="multiple_visible">
                <span class="text-primary" style="font-weight: 400; font-size: 12px">
                    【加倍模式说明】
                </span>
                <br/>
                <span class="text-primary" style="font-weight: 400; font-size: 12px">
                      只适用于经常小金额高杠杆交易的交易员。
                </span>
                <br/>
                <span style="font-weight: 400; font-size: 12px; color: red">
                      如果跟单的交易员经常满仓交易，请不要使用此功能！
                </span>
              </div>
            </a-col>

            <a-col :span="14">
              <a-row type="flex" justify="space-between" align="bottom">
                <a-col :span="18">
                  <a-form-item class="mb-10" label="交易员本金（将作为计算每次开单的固定对标金额）" :colon="false">
                    <a-input placeholder=">100 (可手动修改)" prefix="$" suffix="USDT" v-model="benchMark"/>
                  </a-form-item>
                </a-col>
                <a-col :span="4">
                  <a-button type="primary" style="margin-bottom: 14px" @click="getBenchMark">
                    {{ role_type === '3' ? '预估本金' : '自动获取'}}
                  </a-button>
                </a-col>
              </a-row>
            </a-col>

            <a-col :span="14" v-if="form.getFieldValue('follow_type') === '2'">
              <a-form-item class="mb-10" label="投资额（将作为计算每次开单的金额基数）" :colon="false">
                <a-input placeholder=">100 注意：金额过低可能会无法开单" prefix="$" suffix="USDT"
                         v-decorator="['investment',{ rules: [
                             { required: true, message: '请输入你的投资额！' },
                             { min: 1, message: '长度不能少于1位！' },
                             { validator: (rule, value, callback) => {
                                const numberValue = parseFloat(value);
                                if (isNaN(numberValue) || !isFinite(numberValue)) {
                                  callback('请输入有效的数字！');
                                } else if (numberValue < 100) {
                                  callback('输入数值必须大于100');
                                } else {
                                  callback();
                                }
                              },
                              trigger: 'change'
                            },
                          ]
                         },]"/>
              </a-form-item>
              <span class="text-primary" style="font-weight: 400; font-size: 12px">
                    【智能跟单说明】
              </span>
              <br/>
              <span class="text-primary" style="font-weight: 400; font-size: 12px">
                    实时计算你的投资额和交易员实际本金的比例，按该比例进行下单。
              </span>
              <br/>
              <span class="text-primary" style="font-weight: 400; font-size: 12px">
                    如果一个API同时跟单多名交易员，建议累计投资额不要超过实际账户本金，否则会有很大爆仓风险。
              </span>
            </a-col>
            <a-col :span="14">
              <a-form-item class="mb-10" label="杠杆设置" :colon="false">
                <a-radio-group button-style="solid" style="margin-right: 10px"
                               v-decorator="['lever_set', { initialValue: leverSetInitialValue }]">
                  <a-radio-button value="1" v-if="trader_platform !== '4'">跟随交易员</a-radio-button>
                  <a-radio-button value="2">自定义杠杆</a-radio-button>
                </a-radio-group>
                <a-input placeholder="1至75之间任意整数" style="width: 200px" v-if="form.getFieldValue('lever_set') === '2'"
                         v-decorator="['leverage',{ rules: [
                             { validator: (rule, value, callback) => {
                                const numberValue = parseFloat(value);
                                if (isNaN(numberValue) || !isFinite(numberValue)) {
                                  callback('请输入有效的数字！');
                                } else if (numberValue < 1) {
                                  callback('输入数值必须大于1');
                                } else if (numberValue > 75) {
                                  callback('输入数值必须小于75');
                                } else if (!/^\d+(\.\d+)?$/.test(value)) {
                                  callback('请输入标准的数字格式，不要包含非数字字符');
                                }else {
                                  callback();
                                }
                              },
                              trigger: 'change'
                            },
                          ]
                         },]"/>
              </a-form-item>
              <div v-if="form.getFieldValue('lever_set') === '2'">
                <span class="text-primary" style="font-weight: 400; font-size: 12px">
                  【自定义杠杆说明】
                </span>
                <br/>
                <span class="text-primary" style="font-weight: 400; font-size: 12px">
                  假设自定义杠杆为20，即代表可以开出价值20倍本金的持仓。
                </span>
                <br/>
                <span class="text-primary" style="font-weight: 400; font-size: 12px">
                  相反，若设置下单杠杆为3，此时当交易员的净杠杆(即持仓价值与本金的比值)超过3倍，那您的本金即以全部作为保证金而无法再加仓或开新的仓位。
                </span>
              </div>
            </a-col>
            <a-col :span="14">
              <a-form-item class="mb-10" label="开仓模式（交易员每新开一个币种合约时生效）" :colon="false">
                <a-radio-group button-style="solid" v-decorator="['first_open_type', { initialValue: '1' }]">
                  <a-radio-button value="1">当前市价</a-radio-button>
                  <a-radio-button value="2">区间委托</a-radio-button>
                </a-radio-group>
              </a-form-item>
            </a-col>
            <a-col :span="14" v-if="form.getFieldValue('first_open_type') === '2'">
              <a-form-item class="mb-10" label="交易员收益区间" :colon="false">
                <a-input placeholder="5（交易员收益率小于5%时开仓），-5（亏损大于5%时开仓）" prefix=" < " suffix="%"
                         v-decorator="['uplRatio',{ rules: [
                     { required: true, message: '请输入你的止盈百分比！' },
                     { validator: (rule, value, callback) => {
                        const numberValue = parseFloat(value);
                        if (isNaN(numberValue) || !isFinite(numberValue)) {
                          callback('请输入有效的数字！');
                        } else if (!/^-?\d+(\.\d+)?$/.test(value)) {
                          callback('请输入标准的数字格式，不要包含非数字字符');
                        } else {
                          callback();
                        }
                      },
                      trigger: 'change'
                    },
                  ]
                 },]"/>
              </a-form-item>
              <span class="text-primary" style="font-weight: 400; font-size: 12px">
                    【开仓模式说明】
              </span>
              <br/>
              <span class="text-primary" style="font-weight: 400; font-size: 12px">
                      区间限价开仓只在交易员新开仓时生效，加仓时不生效。该模式在其他交易所也可使用。
              </span>
              <br/>
              <span class="text-primary" style="font-weight: 400; font-size: 12px">
                      系统会自动监控最合适的进场点位第一时间开仓。
              </span>
            </a-col>
            <a-col :span="14">
              <a-form-item class="mb-10" label="首单跟单设置" :colon="false">
                <a-radio-group button-style="solid" v-decorator="['first_order_set', { initialValue: '1' }]">
                  <a-radio-button value="1">有新的加仓，立即跟单</a-radio-button>
                </a-radio-group>
              </a-form-item>
            </a-col>

            <!-- 更多高级配置 -->
            <a-col :span="14" style="margin-top: 10px">
              <a class="text-dark" @click="toggleShowLess('wechat')" style="font-weight: 600">
                高级设置
                <a-icon :type="showLess ? 'up' : 'down'" class="ml-5"/>
              </a>
            </a-col>

            <a-col :span="14" v-if="showLess">
              <a-row type="flex" align="middle" style="margin-top: 20px;">
                <a-col :span="24" :md="12" class="col-info">
                  <div class="avatar-info">
                    <p class="font-semibold m-0" style="font-size: 14px;font-weight: 600;color: #141414;">🔁 反向跟单 ( 娱乐功能
                      )</p>
                  </div>
                </a-col>
                <a-col :span="24" :md="12" style="display: flex; align-items: center; justify-content: flex-end">
                  <small class="mr-5" v-if="posSide_set_visible === false">关闭</small>
                  <small class="mr-5" v-if="posSide_set_visible === true">开启</small>
                  <a-switch v-model="posSide_set_visible" @change="onChangeMode"/>
                </a-col>
              </a-row>

              <a-row type="flex" align="middle" style="margin-top: 20px;">
                <a-col :span="24" :md="12" class="col-info">
                  <div class="avatar-info">
                    <p class="font-semibold m-0" style="font-size: 14px;font-weight: 600;color: #141414;">🚀 极速跟单 ( 限时免费
                      )</p>
                  </div>
                </a-col>
                <a-col :span="24" :md="12" style="display: flex; align-items: center; justify-content: flex-end">
                  <small class="mr-5" v-if="fast_mode_visible === false">关闭</small>
                  <small class="mr-5" v-if="fast_mode_visible === true">开启</small>
                  <a-switch v-model="fast_mode_visible" @change="onChangeMode"/>
                </a-col>
              </a-row>

              <a-row type="flex" align="middle" style="margin-top: 20px;">
                <a-col :span="24" :md="12" class="col-info">
                  <div class="avatar-info">
                    <p class="font-semibold m-0" style="font-size: 14px;font-weight: 600;color: #141414;">⚠️ 交易止盈止损</p>
                  </div>
                </a-col>
                <a-col :span="24" :md="12" style="display: flex; align-items: center; justify-content: flex-end">
                  <small class="mr-5" v-if="trade_trigger_visible === false">关闭</small>
                  <small class="mr-5" v-if="trade_trigger_visible === true">开启</small>
                  <a-switch v-model="trade_trigger_visible" @change="onChangeMode"/>
                </a-col>
              </a-row>
              <a-form-item class="mb-10" label="止盈百分比" :colon="false" v-if="trade_trigger_visible">
                <a-input placeholder="eg. 20（每笔交易盈利20%时止盈），0为不设置止盈" suffix="%"
                         v-decorator="['tp_trigger_px',{ rules: [
                             { required: true, message: '请输入你的止盈百分比！' },
                             { validator: (rule, value, callback) => {
                                const numberValue = parseFloat(value);
                                if (isNaN(numberValue) || !isFinite(numberValue)) {
                                  callback('请输入有效的数字！');
                                } else if (numberValue < 0) {
                                  callback('输入数值必须大于0');
                                }  else if (!/^\d+(\.\d+)?$/.test(value)) {
                                  callback('请输入标准的数字格式，不要包含非数字字符');
                                }else {
                                  callback();
                                }
                              },
                              trigger: 'change'
                            },
                          ]
                         },]"/>
              </a-form-item>
              <a-form-item class="mb-10" label="止损百分比" :colon="false" v-if="trade_trigger_visible">
                <a-input placeholder="eg. 20（每笔交易亏损20%时止损），0为不设置止损" suffix="%"
                         v-decorator="['sl_trigger_px',{ rules: [
                             { required: true, message: '请输入你的止损百分比！' },
                             { validator: (rule, value, callback) => {
                                const numberValue = parseFloat(value);
                                if (isNaN(numberValue) || !isFinite(numberValue)) {
                                  callback('请输入有效的数字！');
                                } else if (numberValue < 0) {
                                  callback('输入数值必须大于0');
                                }  else if (!/^\d+(\.\d+)?$/.test(value)) {
                                  callback('请输入标准的数字格式，不要包含非数字字符');
                                }else {
                                  callback();
                                }
                              },
                              trigger: 'change'
                            },
                          ]
                         },]"/>
              </a-form-item>

              <a-row type="flex" align="middle" style="margin-top: 20px;">
                <a-col :span="24" :md="12" class="col-info">
                  <div class="avatar-info">
                    <p class="font-semibold m-0" style="font-size: 14px;font-weight: 600;color: #141414;">⚠️ 多空开仓策略</p>
                  </div>
                </a-col>
                <a-col :span="24" :md="12" style="display: flex; align-items: center; justify-content: flex-end">
                  <small class="mr-5" v-if="pos_visible === false">关闭</small>
                  <small class="mr-5" v-if="pos_visible === true">开启</small>
                  <a-switch v-model="pos_visible" @change="onChangeMode"/>
                </a-col>
                <a-col :span="14" v-if="pos_visible">
                  <a-form-item class="mb-10" label="多空开仓策略设置" :colon="false">
                    <a-radio-group v-decorator="['pos_value', { initialValue: 'long' }]" button-style="solid">
                      <a-radio-button value="long">
                        只跟多单
                      </a-radio-button>
                      <a-radio-button value="short">
                        只跟空单
                      </a-radio-button>
                    </a-radio-group>
                  </a-form-item>
                </a-col>
              </a-row>


              <a-row type="flex" align="middle" style="margin-top: 20px;">
                <a-col :span="24" :md="12" class="col-info">
                  <div class="avatar-info">
                    <p class="font-semibold m-0" style="font-size: 14px;font-weight: 600;color: #141414;">💹
                      24h成交量排行榜跟单</p>
                  </div>
                </a-col>
                <a-col :span="24" :md="12" style="display: flex; align-items: center; justify-content: flex-end">
                  <small class="mr-5" v-if="vol24h_visible === false">关闭</small>
                  <small class="mr-5" v-if="vol24h_visible === true">开启</small>
                  <a-switch v-model="vol24h_visible" @change="onChangeMode"/>
                </a-col>
                <a-col :span="14" v-if="vol24h_visible">
                  <a-form-item class="mb-10" label="榜单排名" :colon="false">
                    <a-input placeholder="eg. 20（只跟排行榜前20的币种）"
                             v-decorator="['vol24h_num',{ rules: [
                               { required: true, message: '排行榜前几？' },
                               { validator: (rule, value, callback) => {
                                  // 检查是否是正整数并在 0 到 50 之间
                                  const isPositiveInteger = /^\d+$/.test(value);
                                  const numberValue = parseInt(value, 10);
                                  if (!isPositiveInteger || numberValue <= 0) {
                                    callback('请输入大于 0 的整数！');
                                  } else if (numberValue >= 50) {
                                    callback('请输入小于 50 的整数！');
                                  } else {
                                    callback();
                                  }
                                },
                                trigger: 'change'
                              },
                            ]
                           },]"/>
                  </a-form-item>
                </a-col>
              </a-row>

              <a-row type="flex" align="middle" style="margin-top: 20px;">
                <a-col :span="24" :md="12" class="col-info">
                  <div class="avatar-info">
                    <p class="font-semibold m-0" style="font-size: 14px;font-weight: 600;color: #141414;">👀
                      交易员本金监控</p>
                  </div>
                </a-col>
                <a-col :span="24" :md="12" style="display: flex; align-items: center; justify-content: flex-end">
                  <small class="mr-5" v-if="balance_monitor_visible === false">关闭</small>
                  <small class="mr-5" v-if="balance_monitor_visible === true">开启</small>
                  <a-switch v-model="balance_monitor_visible" @change="onChangeMode"/>
                </a-col>
                <a-col :span="14" v-if="balance_monitor_visible">
                  <a-form-item class="mb-10" label="最低本金金额" :colon="false" style="width: 400px">
                    <a-input placeholder="eg. 2000（本金低于2000U时，拒绝一切新开仓交易）"
                             v-decorator="['balance_monitor_value',{ rules: [
                               { required: true, message: '监控最低本金金额？' },
                               { validator: (rule, value, callback) => {
                                  // 检查是否是正整数并在 0 到 50 之间
                                  const isPositiveInteger = /^\d+$/.test(value);
                                  const numberValue = parseInt(value, 10);
                                  if (!isPositiveInteger || numberValue <= 100) {
                                    callback('请输入大于 100 的整数！');
                                  } else {
                                    callback();
                                  }
                                },
                                trigger: 'change'
                              },
                            ]
                           },]"/>
                  </a-form-item>
                </a-col>
              </a-row>

              <a-row type="flex" align="middle" style="margin-top: 20px;">
                <a-col :span="24" :md="12" class="col-info">
                  <div class="avatar-info">
                    <p class="font-semibold m-0" style="font-size: 14px;font-weight: 600;color: #141414;">⚪️ 跟单币种白名单</p>
                  </div>
                </a-col>
                <a-col :span="24" :md="12" style="display: flex; align-items: center; justify-content: flex-end">
                  <small class="mr-5" v-if="white_list_visible === false">关闭</small>
                  <small class="mr-5" v-if="white_list_visible === true">开启</small>
                  <a-switch v-model="white_list_visible" @change="onChangeMode"/>
                </a-col>
                <a-col :span="14" v-if="white_list_visible">
                  <a-form-item class="tags-field mb-10" label="输入允许跟单的币种" :colon="false">
                    <a-select mode="tags" v-decorator="['white_list']" style="width: 170%"
                              placeholder="eg. BTC（跟BTC-USDT-SWAP）" @change="handleWhiteTagChange">
                      <a-select-option v-for="tag in white_tags" :key="tag" :value="tag" selected>
                        {{ tag }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
              </a-row>


              <a-row type="flex" align="middle" style="margin-top: 20px;">
                <a-col :span="24" :md="12" class="col-info">
                  <div class="avatar-info">
                    <p class="font-semibold m-0" style="font-size: 14px;font-weight: 600;color: #141414;">⚫️ 跟单币种黑名单</p>
                  </div>
                </a-col>
                <a-col :span="24" :md="12" style="display: flex; align-items: center; justify-content: flex-end">
                  <small class="mr-5" v-if="black_list_visible === false">关闭</small>
                  <small class="mr-5" v-if="black_list_visible === true">开启</small>
                  <a-switch v-model="black_list_visible" @change="onChangeMode"/>
                </a-col>
                <a-col :span="14" v-if="black_list_visible">
                  <a-form-item class="tags-field mb-10" label="输入禁止跟单的币种" :colon="false">
                    <a-select mode="tags" v-decorator="['black_list']" style="width: 170%"
                              placeholder="eg. BTC（不跟BTC-USDT-SWAP）" @change="handleBlackTagChange">
                      <a-select-option v-for="tag in black_tags" :key="tag" :value="tag" selected>
                        {{ tag }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
              </a-row>
            </a-col>
            <!-- 更多高级配置 -->
            <a-col :span="12" style="margin-top: 20px;">
              <a-button :loading="isLoading" type="primary" class="px-25" @click="submit()" style="width: 100%">立即跟单</a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </a-card>
  </div>
</template>

<script>
import http from "../utils/http"


const key = 'updatable';


export default {
  name: "Task-Add",
  data() {
    return {
      // 提交状态
      isLoading: false,

      // 任务参数
      form: this.$form.createForm(this),
      user: '',
      name: '',
      curl_id: '',
      uniqueName: '',
      trader_platform: '',
      benchMark: '',
      role_type: '1',

      // 控制组件
      // 非表单字段的数据
      showLess: false,
      apiOptions: [],  // 用于存储选项数据
      // 控制组件显示的变量
      multiple_visible: false, // 多倍下单开关
      posSide_set_visible: false,  // 反向跟单开关
      fast_mode_visible: true,  // 极速跟单开关
      trade_trigger_visible: false,  // 跟单触发模式(单笔止盈止损)
      pos_visible: false,  // 多空开仓策略开关
      vol24h_visible: false,  // 24h成交量排行榜跟单开关
      balance_monitor_visible: false,  // 交易员本金监控开关
      white_list_visible: false,  //跟单白名单
      black_list_visible: false,  //跟单黑名单
      white_list: [],
      white_tags: ['BTC', 'ETH', 'SOL', 'PEPE'],  // 初始标签列表
      black_list: [],
      black_tags: ['BTC', 'ETH', 'SOL', 'PEPE'],  // 初始标签列表
    }
  },
  created() {
    // const previousPath = this.$route.params.previousPath;
    // console.log('上一级路径是：', previousPath);

    this.fetchApiOptions();

    const id = this.$route.params.id;
    this.uniqueName = id;
    const trader_platform = this.$route.params.trader_platform;
    this.trader_platform = trader_platform;
    if (trader_platform === '6') {
      this.name = this.apiName();
    } else if (trader_platform === '7' || trader_platform === '8') {
      this.curl_id = id;
      this.name = this.curlName();
    } else {
      this.name = id;
    }
    if (id) {
      return
    } else {
      // 处理没有 key 的情况
      this.$router.push("/dashboard");
    }

    // this.form = this.$form.createForm(this);
    this.form.setFieldsValue({
      unique_name: '',
      role_type: '1',
      id: null, // 跟单 API ID
      follow_type: '2',  // 跟单模式
      multiple: 1, // 多倍下单倍数
      sums: '0',  // 单笔跟单金额
      ratio: '0',  // 固定比例跟单
      investment: '0',  // 投资额
      lever_set: '1',  // 自定义杠杆设置
      leverage: '1',  // 自定义杠杆
      reduce_ratio: '0',  // 减仓比例
      first_open_type: '1',  // 开仓模式
      uplRatio: '0',  //交易员当前收益率
      first_order_set: '1',  // 首单跟单设置
      posSide_set: '1',  // 反向跟单设置
      fast_mode: '1',  // 极速跟单
      trade_trigger_mode: '0',  // 跟单触发模式(单笔止盈止损)
      sl_trigger_px: '0',  // 止损价百分比
      tp_trigger_px: '0',  // 止盈价百分比
      pos_mode: '0',  // 多空开仓策略
      pos_value: 'long', // 多空策略long short
      vol24h_mode: '0',  // 24h成交量排行榜跟单模式
      vol24h_num: '0',
      balance_monitor_mode: '0', // 交易员本金监控开关
      balance_monitor_value: '0',
      white_list_mode: '0',  //跟单白名单
      white_list: [],
      black_list_mode: '0',  //跟单黑名单
      black_list: [],
    });
  },


  computed: {
    // 跟单hot需要自己设置杠杆
    leverSetInitialValue() {
      return this.trader_platform !== '4' ? '1' : '2';
    },
  },

  methods: {
    // 加载数据
    // 获取curl_name
    async curlName() {
      const response = await http.post('/api/curlname/?token=' + localStorage.getItem("token"), {
        curl_id: this.curl_id,
      });
      if (response.data.code === 0) {
        this.name = response.data.data;
      } else {
        this.$message.error({content: response.data.error, key, duration: 2});
      }
    },
    // 获取api_name
    async apiName() {
      const response = await http.post('/api/apiname/?token=' + localStorage.getItem("token"), {
        api_id: this.uniqueName,
      });
      if (response.data.code === 0) {
        this.name = response.data.data;
      } else {
        this.$message.error({content: response.data.error, key, duration: 2});
      }
    },
    // 基础配置
    // 获取跟单API信息
    async fetchApiOptions() {
      try {
        const response = await http.get('/api/apiadd/?token=' + localStorage.getItem("token"));
        console.log("API Response:", response.data);
        if (response.data && Array.isArray(response.data.data)) {
          this.user = response.data.data[0].user;
          this.apiOptions = response.data.data.filter(item => item.is_readonly === false).map(item => ({
            api_name: item.api_name,
            id: item.id
          }));
        } else {
          console.error("预期的数据格式不正确");
        }
      } catch (error) {
        console.error("获取数据失败:", error);
      }
    },
    // 更多配置
    toggleShowLess(e) {
      this.showLess = !this.showLess;
    },
    onChangeMode() {
      // 更新 posSide_set
      if (this.posSide_set_visible) {
        this.form.setFieldsValue({posSide_set: '2'});
      } else {
        this.form.setFieldsValue({posSide_set: '1'});
      }

      // 更新 fast_mode
      if (this.fast_mode_visible) {
        this.form.setFieldsValue({fast_mode: '1'});
      } else {
        this.form.setFieldsValue({fast_mode: '0'});
      }

      // 更新 trade_trigger_mode
      if (this.trade_trigger_visible) {
        this.form.setFieldsValue({trade_trigger_mode: '1'});
      } else {
        this.form.setFieldsValue({trade_trigger_mode: '0'});
      }
    },

    handleWhiteTagChange(value) {
      // 过滤掉黑名单中的标签
      const filteredTags = value.filter(tag => {
        if (this.black_list.includes(tag)) {
          this.$message.error(`标签 "${tag}" 已存在于黑名单中，不能添加到白名单`);
          return false; // 如果标签在黑名单中，则过滤掉
        }
        return true; // 否则保留标签
      });

      // 更新 white_list
      this.white_list = filteredTags;

      // 打印调试信息
      // console.log("白名单标签:", this.white_list);
    },
    handleBlackTagChange(value) {
      // 过滤掉白名单中的标签
      const filteredTags = value.filter(tag => {
        if (this.white_list.includes(tag)) {
          this.$message.error(`标签 "${tag}" 已存在于白名单中，不能添加到黑名单`);
          return false; // 如果标签在白名单中，则过滤掉
        }
        return true; // 否则保留标签
      });

      // 更新 black_list
      this.black_list = filteredTags;

      // 打印调试信息
      // console.log("黑名单标签:", this.black_list);
    },

    // 获取交易员对标资金
    async getBenchMark() {

        const data = {
          trader_platform: this.trader_platform,
          role_type: this.role_type,
          uniqueName: this.trader_platform === '7' || this.trader_platform === '8' ? this.form.getFieldValue('unique_name'): this.uniqueName,
        }
        const response = await http.post('/api/trader_balance/?token=' + localStorage.getItem("token"), data);
        if (response.data.code === 0) {
          this.benchMark = response.data.data;
          this.$message.success(response.data.msg);
        } else {
          this.$message.error(response.data.msg);
        }

    },

    // 提交任务信息
    submit() {
      this.isLoading = true;
      this.$message.loading({ content: '任务提交中，请稍后...', key, duration: 0 });
      this.form.validateFields(async (err, values) => {
        if (!err) {
          try {
            const data = {
              trader_platform: this.trader_platform,
              uniqueName: this.trader_platform === '7' || this.trader_platform === '8' ? values.unique_name + '-' + this.curl_id : this.uniqueName,
              api: values.id,
              follow_type: values.follow_type,
              multiple: values.multiple,
              sums: values.sums,
              ratio: values.ratio,
              lever_set: values.lever_set,
              leverage: values.leverage,
              first_open_type: values.first_open_type,
              uplRatio: values.uplRatio,
              first_order_set: values.first_order_set,
              posSide_set: this.posSide_set_visible ? '2' : '1',
              user: this.user, // 确保 this.user 已在组件中定义
              role_type: '1',
              reduce_ratio: values.reduce_ratio,
              fast_mode: this.fast_mode_visible ? '1' : '0',
              benchMark: this.benchMark,
              investment: values.investment,
              trade_trigger_mode: this.trade_trigger_visible ? '1' : '0',
              sl_trigger_px: values.sl_trigger_px,
              tp_trigger_px: values.tp_trigger_px,
              pos_mode: this.pos_visible ? '1' : '0',
              pos_value: values.pos_value,
              vol24h_mode: this.vol24h_visible ? '1' : '0',  // 24h成交量排行榜跟单模式
              vol24h_num: values.vol24h_num,
              balance_monitor_mode: this.balance_monitor_visible ? '1' : '0',  // 账户余额监控模式
              balance_monitor_value: values.balance_monitor_value,
              white_list_mode: this.white_list_visible ? '1' : '0',  //跟单白名单
              white_list: this.white_list,
              black_list_mode: this.black_list_visible ? '1' : '0',  //跟单黑名单
              black_list: this.black_list,
            };

            const response = await http.post(
                '/api/taskadd/?token=' + localStorage.getItem('token'),
                data
            );
            if (response.data && response.data.code === 0) {
              this.$message.success({ content: '创建成功', key, duration: 2 });
              this.$router.push({path: '/tasklist'});
            } else if (response.data && response.data.code === 1001) {
              this.$message.error({ content: response.data.error, key, duration: 2 });
              this.isLoading = false;
            } else {
              this.$message.error({ content: '创建失败', key, duration: 2 });
              this.isLoading = false;
            }
          } catch (error) {
            console.error({ content: error, key, duration: 2 });
            // 处理错误
          }
        } else {
          // 处理表单验证错误
          console.error('表单验证错误:', err);
          this.$message.error({ content: '请检查表单输入是否正确', key, duration: 2 });
          this.isLoading = false;
        }
      });
    },
  },
}
</script>

<style lang="scss">

.form-tag.ant-tag {
  border-radius: 20px;
  padding: 4px 10px;
  font-size: 12px;
  font-weight: 500;
  margin-right: 3.75px;
  margin-bottom: 3.75px;
  background-color: #3a416f;
  border: 1px solid #3a416f;
  color: #fff;
}
.form-tag.ant-tag .anticon-close {
  color: #fff;
  height: 16px;
  border-left: 1px solid hsla(0,0%,100%,.3);
  padding-left: 5px;
  padding-top: 2px;
  opacity: .75;
}
.form-tag.ant-tag .anticon-close:hover {
  color: #fff;
  opacity: 1;
}
.tags-field .ant-input {
  margin-bottom: 5px;
  margin-top: 4px;
}

.tags-field .ant-select {
  .ant-select-selection__choice__remove i {
    color: #fff;
    height: 16px;
    border-left: 1px solid hsla(0, 0%, 100%, .3);
    padding-left: 5px;
    padding-top: 2px;
    opacity: .75;

    &:hover {
      color: #fff;
      opacity: 1;
    }
  }

  .ant-select-selection__rendered > ul > li:not(.ant-select-search) {
    border-radius: 20px;
    padding: 2px 27px 2px 10px;
    font-size: 12px;
    font-weight: 500;
    margin-right: 3.75px;
    margin-bottom: 3.75px;
    background-color: #3a416f;
    border: 1px solid #3a416f;
    color: #fff;
    line-height: 2;
    height: 30px;
  }

  .ant-select-selection--multiple {
    padding: 8px 10px;
  }
}
</style>